import { render, staticRenderFns } from "./MessageDetail.vue?vue&type=template&id=68220d4e&scoped=true"
import script from "./MessageDetail.vue?vue&type=script&lang=js"
export * from "./MessageDetail.vue?vue&type=script&lang=js"
import style0 from "./MessageDetail.vue?vue&type=style&index=0&id=68220d4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68220d4e",
  null
  
)

export default component.exports